import script from "./MemorialLoadingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MemorialLoadingPage.vue?vue&type=script&setup=true&lang=js"

import "./MemorialLoadingPage.vue?vue&type=style&index=0&id=86af33ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86af33ae"]])

export default __exports__